import {SendRequestFunction} from '@stripe-internal/stripethirdparty/lib/shared/types';
import {ChildDataTypes} from '@stripe-internal/stripethirdparty';
import {
  GetConversationApi,
  GetMessagesApi,
  GetParticipantApi,
  GetUserApi,
  InitializeApi,
  LeaveConversationApi,
  SendFileApi,
  SendMessageApi,
  SendTypingApi,
  SendUserEndedChatMessageApi,
  ShutdownApi,
} from '@stripe-internal/stripethirdparty/lib/shared/TwilioConversationsTypes';

export type STPTwilioInput = ChildDataTypes['TwilioConversations']['input'];
export type STPTwilioOutput = ChildDataTypes['TwilioConversations']['output'];

export class STPTwilio {
  private sendRequest: SendRequestFunction<'TwilioConversations'>;

  constructor(sendRequest: SendRequestFunction<'TwilioConversations'>) {
    this.sendRequest = sendRequest;
  }

  async initialize(
    params: InitializeApi['input']['params'],
  ): Promise<InitializeApi['output']> {
    return this.sendRequest({
      method: 'initialize',
      params,
    }) as Promise<InitializeApi['output']>;
  }

  async shutdown(): Promise<ShutdownApi['output']> {
    return this.sendRequest({
      method: 'shutdown',
      params: undefined,
    }) as Promise<ShutdownApi['output']>;
  }

  async getMessages(
    params: GetMessagesApi['input']['params'],
  ): Promise<GetMessagesApi['output']> {
    return this.sendRequest({method: 'getMessages', params}) as Promise<
      GetMessagesApi['output']
    >;
  }

  async getConversation(
    params: GetConversationApi['input']['params'],
  ): Promise<GetConversationApi['output']> {
    return this.sendRequest({method: 'getConversation', params}) as Promise<
      GetConversationApi['output']
    >;
  }

  async leaveConversation(
    params: LeaveConversationApi['input']['params'],
  ): Promise<LeaveConversationApi['output']> {
    return this.sendRequest({method: 'leaveConversation', params}) as Promise<
      LeaveConversationApi['output']
    >;
  }

  async sendMessage(
    params: SendMessageApi['input']['params'],
  ): Promise<SendMessageApi['output']> {
    return this.sendRequest({method: 'sendMessage', params}) as Promise<
      SendMessageApi['output']
    >;
  }

  async sendFile(
    params: SendFileApi['input']['params'],
  ): Promise<SendFileApi['output']> {
    return this.sendRequest({method: 'sendFile', params}) as Promise<
      SendFileApi['output']
    >;
  }

  async sendTyping(
    params: SendTypingApi['input']['params'],
  ): Promise<SendTypingApi['output']> {
    return this.sendRequest({method: 'sendTyping', params}) as Promise<
      SendTypingApi['output']
    >;
  }

  async sendUserEndedChatMessage(
    params: SendUserEndedChatMessageApi['input']['params'],
  ): Promise<SendUserEndedChatMessageApi['output']> {
    return this.sendRequest({
      method: 'sendUserEndedChatMessage',
      params,
    }) as Promise<SendUserEndedChatMessageApi['output']>;
  }

  async getParticipant(
    params: GetParticipantApi['input']['params'],
  ): Promise<GetParticipantApi['output']> {
    return this.sendRequest({method: 'getParticipant', params}) as Promise<
      GetParticipantApi['output']
    >;
  }

  async getUser(
    params: GetUserApi['input']['params'],
  ): Promise<GetUserApi['output']> {
    return this.sendRequest({method: 'getUser', params}) as Promise<
      GetUserApi['output']
    >;
  }
}
